export enum SidePanelDocCollection { //eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  Ranges='SE-PES-Ranges',
  Products='SE-Products'
}
